import { FormField } from '@sitecore-jss/sitecore-jss-forms';
import { FieldProps } from '@sitecore-jss/sitecore-jss-react-forms';

import { RichTextViewModel } from '../../types/richText';

const TspRichText: React.FC<FieldProps<FormField<RichTextViewModel>>> = ({ field }) =>
  field.model.richText ? <div dangerouslySetInnerHTML={{ __html: field.model.richText }} /> : null;

export default TspRichText;
